var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloseCrossBtn = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "m8 8.707-5.646 5.647-.708-.707L7.293 8 1.646 2.354l.708-.708L8 7.293l5.647-5.647.707.708L8.707 8l5.647 5.647-.707.707z",
  clipRule: "evenodd"
})));
export default SvgCloseCrossBtn;